import getRandomInt from "../util/randomNumber";

const heatMapData = [
    {
      id: "INAP",
      state: "Andhra Pradesh",
      value: getRandomInt(),
      condition: [79.73999, 15.9129],
    },
    {
      id: "INAR",
      state: "Arunachal Pradesh",
      value: getRandomInt(),
      condition: [94.7278, 28.218],
    },
    {
      id: "INAS",
      state: "Assam",
      value: getRandomInt(),
      condition: [92.9376, 26.2006],
    },
    {
      id: "INBR",
      state: "Bihar",
      value: getRandomInt(),
      condition: [85.3131, 25.0961],
    },
    {
      id: "INCT",
      state: "Chhattisgarh",
      value: getRandomInt(),
      condition: [81.8661, 21.2787],
    },
    { id: "INGA", state: "Goa", value: 21, condition: [74.124, 15.2993] },
    { id: "INGJ", state: "Gujarat", value: 22, condition: [71.1924, 22.2587] },
    {
      id: "INHR",
      state: "Haryana",
      value: getRandomInt(),
      condition: [76.0856, 29.0588],
    },
    {
      id: "INHP",
      state: "Himachal Pradesh",
      value: 24,
      condition: [77.1734, 31.1048],
    },
    { id: "INJH", state: "Jharkhand", value: 26, condition: [85.2799, 23.6102] },
    { id: "INKA", state: "Karnataka", value: 27, condition: [75.7139, 15.3173] },
    {
      id: "INKL",
      state: "Kerala",
      value: getRandomInt(),
      condition: [76.2711, 10.8505],
    },
    {
      id: "INMP",
      state: "Madhya Pradesh",
      value: getRandomInt(),
      condition: [78.6569, 22.9734],
    },
    {
      id: "INMH",
      state: "Maharashtra",
      value: getRandomInt(),
      condition: [75.7139, 19.7515],
    },
    {
      id: "INMN",
      state: "Manipur",
      value: getRandomInt(),
      condition: [93.9063, 24.6637],
    },
    { id: "INML", state: "Meghalaya", value: 59, condition: [91.3662, 25.467] },
    {
      id: "INMZ",
      state: "Mizoram",
      value: getRandomInt(),
      condition: [92.9376, 23.1645],
    },
    { id: "INNL", state: "Nagaland", value: 59, condition: [94.5624, 26.1584] },
    { id: "INOR", state: "Odisha", value: 59, condition: [85.0985, 20.9517] },
    {
      id: "INPB",
      state: "Punjab",
      value: getRandomInt(),
      condition: [75.3412, 31.1471],
    },
    {
      id: "INRJ",
      state: "Rajasthan",
      value: getRandomInt(),
      condition: [74.2179, 27.0238],
    },
    {
      id: "INSK",
      state: "Sikkim",
      value: getRandomInt(),
      condition: [88.5122, 27.533],
    },
    {
      id: "INTN",
      state: "Tamil Nadu",
      value: getRandomInt(),
      condition: [78.6569, 11.1271],
    },
    {
      id: "INTG",
      state: "Telangana",
      value: getRandomInt(),
      condition: [79.0193, 18.1124],
    },
    { id: "INTR", state: "Tripura", value: 14, condition: [91.9882, 23.9408] },
    {
      id: "INUT",
      state: "Uttarakhand",
      value: getRandomInt(),
      condition: [79.0193, 30.0668],
    },
    {
      id: "INUP",
      state: "Uttar Pradesh",
      value: 15,
      condition: [80.9462, 26.8467],
    },
    { id: "INWB", state: "West Bengal", value: 17, condition: [87.855, 22.9868] },
    {
      id: "INAN",
      state: "Andaman and Nicobar Islands",
      value: getRandomInt(),
      condition: [92.6586, 11.7401],
    },
    {
      id: "INCH",
      state: "Chandigarh",
      value: getRandomInt(),
      condition: [76.7794, 30.7333],
    },
    {
      id: "INDN",
      state: "Dadra and Nagar Haveli",
      value: 19,
      condition: [73.0169, 20.1809],
    },
    {
      id: "INDD",
      state: "Daman and Diu",
      value: 20,
      condition: [72.8328, 20.3974],
    },
    { id: "INDL", state: "Delhi", value: 59, condition: [77.1025, 28.7041] },
    {
      id: "INJK",
      state: "Jammu and Kashmir",
      value: 25,
      condition: [75.3412, 33.7782],
    },
    {
      id: "INLA",
      state: "Ladakh",
      value: getRandomInt(),
      condition: [77.577, 34.1526],
    },
    {
      id: "INLD",
      state: "Lakshadweep",
      value: getRandomInt(),
      condition: [72.6418, 10.328],
    },
    {
      id: "INPY",
      state: "Puducherry",
      value: getRandomInt(),
      condition: [79.8083, 11.9416],
    },
  ];

  export default heatMapData